<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">Financial</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <div class="pea-panel" v-if="panelOpen" >
        <el-row :gutter="20" class="assetSection">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <h4 style="margin-top: 0;">Capital Assets</h4>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-for="(capitalAsset, index) in capitalAssets" v-bind:key="capitalAsset.id" class="capitalAsset">
              <div v-if="!capitalAssets[index].removeAsset">
                <el-col :span="24">
                  <financial-asset ref="capitalAssetRef" :disabled="disabled" v-on:classificationChange="updateBasedOnClassificationChange"
                    v-on:financialAssetValidation="updateValidation" v-model="capitalAssets[index]" :peaId="peaId"
                    :startingYear="startingYearData" v-on:cloudComputingChange="handleCloudComputingChange(index, $event)" :showHelp="true"></financial-asset>
                  <el-button type="danger" :disabled="disabled" icon="el-icon-delete" @click="removeFromArray(capitalAssets, index)" class="deleteAssetButton"></el-button>
                </el-col>
              </div>
            </el-row>
            <div class="assetsTotalRow">
                <strong>Capital Asset(s) Total: $ {{ formatMoney(capitalAssetsTotalAmount) }}</strong>
                <el-button type="success" :disabled="disabled" @click="addToArray(capitalAssets, 1)">Add new Capital Asset</el-button>
            </div>
          </el-col>
        </el-row>
        <hr class="thin">

        <el-row :gutter="20" class="assetSection">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <h4>Operating Leases</h4>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-for="(operatingLease, index) in operatingLeases" v-bind:key="operatingLease.id">
              <div v-if="!operatingLeases[index].removeAsset">
                <el-col :span="24">
                  <financial-asset ref="operatingLeaseRef" :disabled="disabled" v-on:classificationChange="updateBasedOnClassificationChange" v-on:financialAssetValidation="updateValidation" v-model="operatingLeases[index]" :peaId="peaId" :startingYear="startingYearData" v-on:cloudComputingChange="handleCloudComputingChange(index, $event)" depreciationText="Lease Length (Years)"></financial-asset>
                  <el-button type="danger" :disabled="disabled" icon="el-icon-delete" @click="removeFromArray(operatingLeases, index)" class="deleteAssetButton"></el-button>
                </el-col>
              </div>
            </el-row>
            <div class="assetsTotalRow">
                <strong>Operating Lease(s) Total: $ {{ formatMoney(operatingLeasesTotalAmount) }}</strong>
                <el-button type="success" :disabled="disabled" @click="addToArray(operatingLeases, 2)">Add new Operating Lease</el-button>
            </div>
          </el-col>
        </el-row>
        <hr class="thin">

        <el-row :gutter="20" class="assetSection">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <h4>Other Expenditure</h4>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-for="(otherExpenditure,index) in otherExpenditures" v-bind:key="otherExpenditure.id">
              <div v-if="!otherExpenditures[index].removeAsset">
                <el-col :span="24">
                  <financial-asset ref="otherExpenditureRef" :disabled="disabled" v-on:classificationChange="updateBasedOnClassificationChange" v-on:financialAssetValidation="updateValidation" v-model="otherExpenditures[index]" :peaId="peaId" :startingYear="startingYearData" v-on:cloudComputingChange="handleCloudComputingChange(index, $event)" :showDepreciation="false"></financial-asset>
                  <el-button type="danger" :disabled="disabled" icon="el-icon-delete" @click="removeFromArray(otherExpenditures, index)" class="deleteAssetButton"></el-button>
                </el-col>
              </div>
            </el-row>
            <div class="assetsTotalRow">
                <strong>Other Expenditure(s) Total: $ {{ formatMoney(otherExpendituresTotalAmount) }}</strong>
                <el-button type="success" :disabled="disabled" @click="addToArray(otherExpenditures, 3)">Add new Other Expenditure</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </transition>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-financial-assets',
  props: {
    peaId: {
      default: 0
    },
    disabled: {
      default: false
    },
    startingYear: {
      default: new Date().getFullYear()
    }
  },
  data () {
    return {
      callData: [],
      capitalAssets: [],
      operatingLeases: [],
      otherExpenditures: [],
      capitalAssetsTotalAmount: 0,
      operatingLeasesTotalAmount: 0,
      otherExpendituresTotalAmount: 0,
      blankAsset: {
        id: 0,
        peaId: this.peaId,
        name: '',
        description: '',
        type: 0,
        yearOneAmount: 0,
        yearTwoAmount: 0,
        yearThreeAmount: 0,
        yearFourAmount: 0,
        totalAmount: 0,
        inProfitPlan: false,
        classificationId: null,
        depreciation: null,
        removeAsset: false,
        cloudComputing: null
      },
      allAssetState: true,
      panelOpen: true
    }
  },
  computed: {
    startingYearData: {
      get: function () {
        return this.startingYear
      },
      set: function (modifiedValue) {
        this.$emit('startingYearData', modifiedValue)
      }
    }
  },
  methods: {
    updateBasedOnClassificationChange () {
      this.$emit('peaFAClassChange')
    },
    handleCloudComputingChange (index, newValue) {
      this.capitalAssets[index].cloudComputing = newValue
    },
    fetchData () {
      this.getCapitalAssets()
      this.getOperatingLeases()
      this.getOtherExpenditures()
    },
    getCapitalAssets () {
      var call = '/getPEAFinancialAssetByType/' + this.peaId + '?type=1'
      this.$axios.get(call).then(response => {
        this.capitalAssets = response.data
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving Capital Assets', response.body, 'error', 30000)
        this.$emit('fetchComplete')
      })
    },
    getOperatingLeases () {
      var call = '/getPEAFinancialAssetByType/' + this.peaId + '?type=2'
      this.$axios.get(call).then(response => {
        this.operatingLeases = response.data
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving Operating Leases Assets', response.body, 'error', 30000)
        this.$emit('fetchComplete')
      })
    },
    getOtherExpenditures () {
      var call = '/getPEAFinancialAssetByType/' + this.peaId + '?type=3'
      this.$axios.get(call).then(response => {
        this.otherExpenditures = response.data
        this.$emit('fetchComplete')
      }).catch(response => {
        helperMethods.showNotification(this.$parent, 'Error retrieving Other Expenditure Assets', response.body, 'error', 30000)
        this.$emit('fetchComplete')
      })
    },
    removeFromArray (assetArray, index) {
      assetArray[index].removeAsset = true
    },
    addToArray (assetArray, type) {
      var newAsset = {}
      for (var attr in this.blankAsset) {
        if (this.blankAsset.hasOwnProperty(attr)) newAsset[attr] = this.blankAsset[attr]
      }
      newAsset.type = type
      assetArray.push(newAsset)
    },
    updateFinancialAssets () {
      var call = '/updateFinancialAssets/' + this.peaId
      var allAssets = this.capitalAssets
      allAssets = allAssets.concat(this.operatingLeases)
      allAssets = allAssets.concat(this.otherExpenditures)
      // PRD.PUB only fix: issue of this call not accepting numbers larger than 32169
      // fix is to pass these numbers as strings
      // only remove if you can test fix ON PRD.PUB
      for (var i = 0; i < allAssets.length; i++) {
        allAssets[i].yearOneAmount = allAssets[i].yearOneAmount.toString()
        allAssets[i].yearTwoAmount = allAssets[i].yearTwoAmount.toString()
        allAssets[i].yearThreeAmount = allAssets[i].yearThreeAmount.toString()
        allAssets[i].yearFourAmount = allAssets[i].yearFourAmount.toString()
        allAssets[i].totalAmount = allAssets[i].totalAmount.toString()
      }
      var toSend = JSON.stringify(allAssets)
      return new Promise((resolve, reject) => {
        this.$axios.post(call, toSend, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(response => {
          // have to update all to get IDs for new assets
          this.capitalAssets = []
          this.operatingLeases = []
          this.otherExpenditures = []
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].type === 1) {
              this.capitalAssets.push(response.data[i])
            } else if (response.data[i].type === 2) {
              this.operatingLeases.push(response.data[i])
            } else {
              this.otherExpenditures.push(response.data[i])
            }
          }
          resolve(response)
        }).catch(response => {
          helperMethods.showNotification(this.$parent, 'Error updating Financial Assets Info', response.body, 'error', 30000)
          // small issue if this fails, causes all totals to recalculate and possibly overflow because of referencing
          for (var i = 0; i < allAssets.length; i++) {
            allAssets[i].yearOneAmount = parseFloat(allAssets[i].yearOneAmount)
            allAssets[i].yearTwoAmount = parseFloat(allAssets[i].yearTwoAmount)
            allAssets[i].yearThreeAmount = parseFloat(allAssets[i].yearThreeAmount)
            allAssets[i].yearFourAmount = parseFloat(allAssets[i].yearFourAmount)
            allAssets[i].totalAmount = parseFloat(allAssets[i].totalAmount)
          }
          this.updateCapitalTotal()
          this.updateOperatingTotal()
          this.updateOtherTotal()
          reject(response)
        })
      })
    },
    startUp () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        this.fetchData()
      }
    },
    updateCapitalTotal () {
      this.capitalAssetsTotalAmount = 0
      for (var i = 0; i < this.capitalAssets.length; i++) {
        if (!this.capitalAssets[i].removeAsset) {
          this.capitalAssetsTotalAmount += ((this.capitalAssets[i].totalAmount === null || this.capitalAssets[i].totalAmount === undefined) ? 0 : this.capitalAssets[i].totalAmount)
        }
      }
    },
    updateOperatingTotal () {
      this.operatingLeasesTotalAmount = 0
      for (var i = 0; i < this.operatingLeases.length; i++) {
        if (!this.operatingLeases[i].removeAsset) {
          this.operatingLeasesTotalAmount += ((this.operatingLeases[i].totalAmount === null) ? 0 : this.operatingLeases[i].totalAmount)
        }
      }
    },
    updateOtherTotal () {
      this.otherExpendituresTotalAmount = 0
      for (var i = 0; i < this.otherExpenditures.length; i++) {
        if (!this.otherExpenditures[i].removeAsset) {
          this.otherExpendituresTotalAmount += ((this.otherExpenditures[i].totalAmount === null) ? 0 : this.otherExpenditures[i].totalAmount)
        }
      }
    },
    checkFormValidation () {
      this.allAssetState = true
      if (this.$refs.capitalAssetRef !== undefined) {
        for (var i = 0; i < this.$refs.capitalAssetRef.length; i++) {
          this.$refs.capitalAssetRef[i].checkAssetValid()
        }
      }
      if (this.$refs.operatingLeaseRef !== undefined) {
        for (i = 0; i < this.$refs.operatingLeaseRef.length; i++) {
          this.$refs.operatingLeaseRef[i].checkAssetValid()
        }
      }
      if (this.$refs.otherExpenditureRef !== undefined) {
        for (i = 0; i < this.$refs.otherExpenditureRef.length; i++) {
          this.$refs.otherExpenditureRef[i].checkAssetValid()
        }
      }
      if (!this.allAssetState) {
        helperMethods.showNotification(this.$parent, 'Invalid Financial requirements', 'Please check Financial section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
      }
      this.$parent.$emit('peaFinancialAssetValidation', this.allAssetState)
    },
    updateValidation (value) {
      if (!value) {
        this.allAssetState = false
      }
      this.financialAssetValid = true
    },
    formatMoney: function (money) {
      return helperMethods.formatMoney(parseFloat(money))
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp',
    // watch each array (deeply to view property changes) to update totals
    capitalAssets: {
      handler: function () {
        this.updateCapitalTotal()
      },
      deep: true
    },
    operatingLeases: {
      handler: function () {
        this.updateOperatingTotal()
      },
      deep: true
    },
    otherExpenditures: {
      handler: function () {
        this.updateOtherTotal()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  h4 {
    background: #839da2;
    color: white;
    padding: 12px 20px;
    margin: 0 -20px 30px;
    font-size: 1.2rem;
    /*border-radius: 6px;*/
    transition: .25s;
  }

  .assetSection {
    transition: .25s;
    margin-left: -20px !important;
    margin-right: -20px !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 20px;
    margin-bottom: 0;
  }

  .assetSection:hover {
    background: aliceblue;
    /*background: linear-gradient(to bottom, aliceblue 96%, aliceblue 96%, white 100%);*/
  }

  .assetSection:hover h4 {
    background: #00a9ce;
  }

  .card {
    transition: .25s;
  }

  .card:hover {
    box-shadow: 0 2px 10px rgba(0,0,0,.25);
  }

  hr.thin {
    margin-top: 0;
    margin-bottom: 40px !important;
  }
</style>
